import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import MaterialTable, { MTableToolbar } from 'material-table';
import { createMuiTheme, Container, Toolbar, Typography, CssBaseline, Tooltip, Snackbar, FormControl, InputLabel, Select, Divider, Fab, AppBar } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { ThemeProvider } from '@material-ui/styles';
import { makeStyles } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import MuiAlert from '@material-ui/lab/Alert';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import ExportIcon from '@material-ui/icons/GetApp';
import FilterListIcon from '@material-ui/icons/FilterList';
import 'date-fns';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import { ConvertToCurrentTimeZone, ConvertTimeZoneOffset } from '../header/timeFormatter';
import { HttpService } from '../../apiAuthorization/httpService';
import { GlobalTheme } from '../../layouts/theme';
import { Context } from '../contexts/siteContext';
import { Theme } from '../contexts/themeContext';
import typesData from '../../data';
import Card from '../card/card.js';
import CardBody from '../card/cardBody.js';
import SmallMenu from '../header/smallMenu';
import StatusIcon from '../common/statusIcon';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const useStyles = makeStyles(theme => ({
    root: {
        '& > *': {
            margin: '7px 0px',
            width: '100%'
        }
    },
    button: {
        width: '15%',
        float: 'right'
    },
    error: {
        fontSize: '12px',
        fontWeight: "bold",
        color: 'red',
        marginTop: '-5px'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    },
    title: {
        flex: 1
    }
}));

export default function RoundReport(props) {
    const classes = useStyles();
    const { defaultSite, sites } = useContext(Context);
    const { theme } = useContext(Theme);
    const [sitesList, setSitesList] = useState([]);
    const [roundTypes, setRoundTypes] = useState([]);
    const [startDate, setStartDate] = useState(ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY", null, defaultSite));
    const [endDate, setEndDate] = useState(ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY", null, defaultSite));
    const [siteId, setSiteId] = useState(-1);
    const [round, setRound] = useState(-1);
    const [roundState, setRoundState] = useState("All");
    const [showFilter, setShowFilter] = useState(false);
    const [openSuccess, setOpenSuccess] = useState(false);
    const [backDrop, setBackDrop] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const currentTheme = theme ? createMuiTheme(GlobalTheme[theme]) : createMuiTheme(GlobalTheme[localStorage.getItem("theme")]);
    const tableHeight = window.innerHeight - (showFilter ? 377 : 210);

    const [rounds, setRounds] = useState({
        columns: [
            { field: 'roundDate', title: 'Round Date', width: '8%', render: rowData => moment(rowData.roundDate).format('MM/DD/YYYY') },
            { field: 'location', title: 'Location', width: '8%' },
            { field: 'siteName', title: 'Site Name', width: '10%' },
            { field: 'roundListName', title: 'Round List Name', width: '10%' },
            { field: 'round', title: 'Round', width: '4%' },
            { field: 'unsatisfactory', title: 'Sat/Unsat', width: '4%', render: rowData => rowData.unsatisfactory ? 'Unsat' : 'Sat' },
            { field: 'comment', title: 'Comment', width: '10%' },
            { field: 'assignedTo', title: 'Assigned to', width: '8%' },
            { field: 'completed', title: 'Completed', width: '4%', render: rowData => rowData.completed ? 'Yes' : 'No' },
            { field: 'managerConfirmed', title: 'Manager Confirmed', width: '4%', render: rowData => rowData.managerConfirmed ? 'Yes' : 'No' },
            { field: 'createdDateTime', title: 'Created Date/Time', width: '7%', render: rowData => ConvertTimeZoneOffset(rowData.createdDateTime, defaultSite) },
            { field: 'createdUser', title: 'Created User', width: '7%' },
            { field: 'modifiedDateTime', title: 'Modified Date/Time', width: '7%', render: rowData => ConvertTimeZoneOffset(rowData.modifiedDateTime, defaultSite) },
            { field: 'modifiedUser', title: 'Modified User', width: '7%' }
        ],
        data: []
    });

    const rowStyle = (rowData, rowIndex) => {
        return { backgroundColor: rowIndex % 2 === 0 ? '' : currentTheme.alternateGridRow };
    };

    const closeSuccessSnackbar = () => {
        setOpenSuccess(false);
    };

    const startDateChanged = date => {
        setStartDate(moment(date).format("MM/DD/YYYY"));
    };

    const endDateChanged = date => {
        setEndDate(moment(date).format("MM/DD/YYYY"));
    };

    const siteChanged = (e) => {
        setSiteId(parseInt(e.target.value));
    };

    const filterChanged = () => {
        setShowFilter(!showFilter);
    };

    const getRounds = () => {
        if (siteId === 0 || (showFilter && (round === 0 || roundState === "0")))
            return;

        let model = {};

        model.Ancestor = (siteId === -1) ? 0 : siteId;
        model.DateStart = startDate;
        model.DateEnd = endDate;
        model.Round = showFilter ? (round === -1) ? 0 : round : 0;
        model.RoundState = showFilter ? roundState : null;
        model.AccessibleSites = sitesList;
        setBackDrop(true);

        HttpService.post('/Round/GetAppRoundsForReport', model)
            .then((result) => {
                setRounds({ ...rounds, data: result.data });
                setBackDrop(false);
            },
                (error) => {
                    console.log(error);
                });
    };

    const exportToExcel = () => {
        if (siteId === 0 || (showFilter && (round === 0 || roundState === "0")))
            return;

        let model = {};
        let parameter = {};
        var index = sitesList.findIndex(item => item.id === siteId);

        parameter.Ancestor = (siteId === -1) ? 0 : siteId;
        parameter.DateStart = startDate;
        parameter.DateEnd = endDate;
        parameter.Round = showFilter ? (round === -1) ? 0 : round : 0;
        parameter.RoundState = showFilter ? roundState : null;
        parameter.AccessibleSites = sitesList;
        model.RoundReportParameter = parameter;
        model.SiteName = sitesList[index].name;
        model.Hour = parseInt(defaultSite.offset);;
        model.TimeZoneDST = parseInt(defaultSite.dst);;
        model.DstStart = moment().month(2).day(0).format("MM/DD/YYYY");;
        model.DstEnd = moment().month(10).day(-7).format("MM/DD/YYYY");;
        setBackDrop(true);

        HttpService.post('/Round/ExportToCSV', model)
            .then((result) => {
                if (result.success) {
                    let fileName = result.name;
                    HttpService.downloadFile('/Report/DownloadFile', { fileName: fileName })
                        .then((response) => {
                            const url = window.URL.createObjectURL(new Blob([response]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.download = fileName;
                            document.body.appendChild(link);
                            link.click();
                            link.parentNode.removeChild(link);
                        });
                }
                else {
                    setSuccessMessage(result.message);
                    setOpenSuccess(true);
                }
                setBackDrop(false);
            },
                (error) => {
                    console.log(error);
                });
    };

    useEffect(() => {
        if (sitesList.length > 0) {
            getRounds();
        }
        // eslint-disable-next-line 
    }, [siteId, startDate, endDate, round, roundState]);

    useEffect(() => {
        let data = sites.slice();
        let index = sites.findIndex(item => item.id === -1);
        if (index === -1) {
            data.unshift({ id: -1, name: "All" });
            setSitesList(data);
        }
        data = typesData.rounds.slice();
        index = data.findIndex(item => item.id === -1);
        if (index === -1) {
            data.unshift({ id: -1, name: "All" });
            setRoundTypes(data);
        }
        // eslint-disable-next-line 
    }, []);

    useEffect(() => {
        setSiteId(defaultSite.id);
        // eslint-disable-next-line 
    }, [sitesList]);

    return (
        <React.Fragment>
            <ThemeProvider theme={currentTheme}>
                <CssBaseline />
                <Backdrop className={classes.backdrop} id="roundBackdrop" open={backDrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Snackbar open={openSuccess} autoHideDuration={3000} onClose={closeSuccessSnackbar} style={{ height: "100%" }}>
                    <Alert onClose={closeSuccessSnackbar} severity="success">
                        {successMessage}
                    </Alert>
                </Snackbar>
                <Container maxWidth="xl" height="100%" className={props.styles}>
                    <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
                        <Toolbar>
                            <Link to="/"><KeyboardBackspaceIcon /></Link>
                            <Grid container direction="row" alignItems="center">
                                <Grid item>
                                    <Typography variant="h6" className={classes.title}>&nbsp;Round Report</Typography>
                                </Grid>
                                <Grid item>
                                    <StatusIcon />
                                </Grid>
                            </Grid>
                            <Grid container justify="flex-end">
                                <Fab style={{ background: currentTheme.secondary, color: "white" }} size="small" aria-label="export" onClick={exportToExcel}>
                                    <Tooltip title="Export" arrow><ExportIcon /></Tooltip>
                                </Fab>
                                <SmallMenu modified={false} />
                                <Tooltip title="Filter" arrow>
                                    <FilterListIcon style={{ cursor: "pointer", float: "right", width: "30px", marginTop: "20px", marginLeft: "20px" }} onClick={filterChanged} />
                                </Tooltip>
                            </Grid>
                        </Toolbar>
                    </AppBar>
                    <Card color="primary" style={{ height: "100%", background: currentTheme.background }}>
                        <CardBody style={{ color: currentTheme.text, marginTop: "50px" }}>
                            <div className={classes.root} autoComplete="off">
                                <Grid
                                    container
                                    direction="row"
                                    alignItems="center"
                                    spacing={1}>
                                    <Grid item xs={12} sm={6}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDatePicker disableToolbar fullWidth autoOk
                                                variant="inline"
                                                inputVariant="outlined"
                                                id="StartDate"
                                                label="Start Date"
                                                format="MM/dd/yyyy"
                                                size="small"
                                                disableFuture="true"
                                                value={startDate}
                                                onChange={date => startDateChanged(date)}
                                                InputAdornmentProps={{ position: "start" }}
                                                PopoverProps={{
                                                    anchorOrigin: { horizontal: "left", vertical: "bottom" },
                                                    transformOrigin: { horizontal: "left", vertical: "top" }
                                                }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDatePicker disableToolbar fullWidth autoOk
                                                variant="inline"
                                                inputVariant="outlined"
                                                id="EndDate"
                                                label="End Date"
                                                format="MM/dd/yyyy"
                                                size="small"
                                                disableFuture="true"
                                                minDate={startDate}
                                                value={endDate}
                                                onChange={date => endDateChanged(date)}
                                                InputAdornmentProps={{ position: "start" }}
                                                PopoverProps={{
                                                    anchorOrigin: { horizontal: "left", vertical: "bottom" },
                                                    transformOrigin: { horizontal: "left", vertical: "top" }
                                                }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                </Grid>
                                {showFilter && <>
                                    <FormControl variant="outlined" margin="dense" className={classes.ddl}>
                                        <InputLabel htmlFor="Site">Site</InputLabel>
                                        <Select
                                            native
                                            label="Site"
                                            size="small"
                                            value={siteId}
                                            onChange={(e) => { siteChanged(e); }}
                                        >
                                            <option aria-label="None" key="0" value="0" />
                                            {
                                                sitesList.map((option, key) => {
                                                    return <option key={option.id} value={option.id} label={option.name} >{option.name}</option>;
                                                })
                                            }
                                        </Select>
                                    </FormControl>
                                    <FormControl variant="outlined" margin="dense" className={classes.ddl}>
                                        <InputLabel htmlFor="Round">Round</InputLabel>
                                        <Select
                                            native
                                            label="Round"
                                            size="small"
                                            value={round}
                                            onChange={(e) => { setRound(parseInt(e.target.value)); }}
                                        >
                                            <option aria-label="None" key="0" value="0" />
                                            {
                                                roundTypes.map((option, key) => {
                                                    return <option key={option.id} value={option.id} label={option.name} >{option.name}</option>;
                                                })
                                            }
                                        </Select>
                                    </FormControl>
                                    <FormControl variant="outlined" margin="dense" className={classes.ddl}>
                                        <InputLabel htmlFor="Status">Status</InputLabel>
                                        <Select
                                            native
                                            label="Status"
                                            size="small"
                                            value={roundState}
                                            onChange={(e) => { setRoundState(e.target.value); }}
                                         >
                                            <option aria-label="None" key="0" value="0" />
                                            {
                                                typesData.roundStates.map((option, key) => {
                                                    return <option key={option.id} value={option.name} label={option.name} >{option.name}</option>;
                                                })
                                            }
                                        </Select>
                                    </FormControl>
                                </>
                                }
                            </div>
                            <Divider style={{ height: '1px', backgroundColor: currentTheme.secondary, marginTop: '5px', marginBottom: '10px' }} />
                            <div style={{ maxWidth: '100%' }}>
                                <MaterialTable
                                    columns={rounds.columns}
                                    data={rounds.data}
                                    components={{
                                        Toolbar: (props) => (
                                            <div
                                                style={{
                                                    height: "0px",
                                                }}
                                            >
                                                <MTableToolbar {...props} />
                                            </div>
                                        )
                                    }}
                                    style={{ backgroundColor: currentTheme.background, border: '1px solid white' }}
                                    options={{
                                        filtering: false,
                                        search: false,
                                        paging: false,
                                        actionsColumnIndex: -1,
                                        minBodyHeight: tableHeight,
                                        maxBodyHeight: tableHeight,
                                        headerStyle: {
                                            fontWeight: 'bold', color: currentTheme.headerColor, backgroundColor: currentTheme.headerBackground
                                        },
                                        actionsCellStyle: {
                                            color: currentTheme.secondary,
                                            hover: 'white'
                                        },
                                        rowStyle: rowStyle
                                    }}
                                />
                            </div>
                        </CardBody>
                    </Card>
                </Container>
            </ThemeProvider>
        </React.Fragment>
    )
}
